(() => {
  'use strict';

  if (window.QMPremiumFinalLoaded) return;
  window.QMPremiumFinalLoaded = true;

  const musicHandles = new Set([
    'vinilos-1',
    'rock',
    'metal',
    'pop',
    'jazz',
    'blues-soul',
    'electronica',
    'hip-hop',
    'reggae-ska',
    'rap',
    'reggaeton',
    'salsa',
    'made-in-espana',
    'ofertas-especiales'
  ]);

  const currentCollectionHandle = () => {
    const match = window.location.pathname.match(/^\/collections\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const setPageContext = () => {
    document.documentElement.classList.toggle('qm-music-catalog', musicHandles.has(currentCollectionHandle()));
  };

  const enhanceFilters = () => {
    document.querySelectorAll('input[name="filter.p.t.category"][value="me-3-3"]').forEach((input) => {
      input.setAttribute('aria-label', 'CD');
      const text = input.closest('.checkbox-facet-label')?.querySelector('.checkbox-facet-label-text');
      if (text) text.textContent = 'CD';
    });
  };

  const updateHeaderGeometry = () => {
    const header = document.getElementById('header');
    if (!header) return;
    const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    document.documentElement.style.setProperty('--qm-header-bottom', bottom + 'px');
  };

  const positionMenuPanel = (item) => {
    if (window.innerWidth < 990) return;
    const panel = item.querySelector(':scope > .navigation-sub-menu');
    const trigger = item.querySelector('.qm-navigation-trigger');
    const header = document.getElementById('header');
    if (!panel || !trigger || !header) return;
    const width = panel.classList.contains('qm-mega-menu--discos')
      ? Math.min(600, Math.max(440, window.innerWidth * 0.46))
      : 286;
    const triggerRect = trigger.getBoundingClientRect();
    const left = Math.max(16, Math.min(triggerRect.left, window.innerWidth - width - 16));
    panel.style.setProperty('--qm-menu-left', Math.round(left) + 'px');
    panel.style.setProperty('--qm-menu-top', Math.round(header.getBoundingClientRect().bottom) + 'px');
  };

  const bindMenuPositioning = () => {
    document.querySelectorAll('.qm-navigation-item').forEach((item) => {
      if (item.dataset.qmPositionBound === 'true') return;
      item.dataset.qmPositionBound = 'true';
      const position = () => positionMenuPanel(item);
      item.addEventListener('pointerenter', position, { passive: true });
      item.querySelector('.qm-navigation-toggle')?.addEventListener('click', () => requestAnimationFrame(position));
      item.addEventListener('focusin', position);
    });
  };

  const bindSearchOutsideClose = () => {
    if (document.documentElement.dataset.qmSearchOutsideBound === 'true') return;
    document.documentElement.dataset.qmSearchOutsideBound = 'true';

    const closeOpenSearchOutside = (event) => {
      document.querySelectorAll('.header-search-modal').forEach((modal) => {
        const toggle = modal.querySelector('.dropdown-modal-toggle');
        if (toggle?.getAttribute('aria-expanded') !== 'true' || modal.contains(event.target)) return;
        toggle.click();
      });
    };

    document.addEventListener('pointerdown', closeOpenSearchOutside, true);
    document.addEventListener('click', closeOpenSearchOutside, true);
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.header-search-modal').forEach((modal) => {
        const toggle = modal.querySelector('.dropdown-modal-toggle');
        if (toggle?.getAttribute('aria-expanded') === 'true') toggle.click();
      });
    }, true);
  };

  const updateCartCounts = (cart) => {
    const count = Number(cart.item_count || 0);
    let liveBadge = document.querySelector('.head-slot-cart-link-quantity');
    if (count > 0 && !liveBadge) {
      const badgeWrap = document.querySelector('#HeaderMiniCart .head-slot-cart-link-wrap');
      if (badgeWrap) {
        liveBadge = document.createElement('span');
        liveBadge.className = 'head-slot-cart-link-quantity';
        badgeWrap.appendChild(liveBadge);
      }
    }
    document.querySelectorAll('[data-cart-count], .cart-count-bubble, .head-slot-cart-count, .head-slot-cart-link-quantity').forEach((node) => {
      if (count === 0 && node.classList.contains('head-slot-cart-link-quantity')) {
        node.remove();
        return;
      }
      node.textContent = String(count);
      node.hidden = count === 0;
    });
  };

  const getCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('No se pudo actualizar la cesta');
    return response.json();
  };

  const getCartSurfaceSections = () => {
    const surfaces = [
      {
        anchor: '#HeaderMiniCart',
        selectors: ['#header-mini-cart-content', '#header-mini-cart-footer']
      },
      {
        anchor: '#main-cart-items',
        selectors: ['#main-cart-items']
      },
      {
        anchor: '#main-cart-footer',
        selectors: ['#main-cart-footer']
      }
    ];
    const sections = new Map();

    surfaces.forEach((surface) => {
      const anchor = document.querySelector(surface.anchor);
      const wrapper = anchor?.closest('.shopify-section[id^="shopify-section-"]');
      const sectionId = wrapper?.id?.replace(/^shopify-section-/, '');
      if (sectionId) sections.set(sectionId, surface.selectors);
    });

    return sections;
  };

  const applyRenderedCartSections = (renderedSections, sections) => {
    if (!renderedSections || !sections?.size) return false;
    let changed = false;

    sections.forEach((selectors, sectionId) => {
      const markup = renderedSections[sectionId];
      if (!markup) return;
      const nextDocument = new DOMParser().parseFromString(markup, 'text/html');
      selectors.forEach((selector) => {
        const current = document.querySelector(selector);
        const next = nextDocument.querySelector(selector);
        if (!current || !next) return;
        current.replaceWith(document.importNode(next, true));
        changed = true;
      });
    });

    if (changed) observeDynamicAreas();
    return changed;
  };

  const cartSurfaceLineCountsMatch = (expectedLines) => {
    const mainCart = document.getElementById('main-cart-items');
    const miniCart = document.getElementById('HeaderMiniCart');
    const mainMatches = !mainCart || mainCart.querySelectorAll('[id^="CartItem-"]').length === expectedLines;
    const miniMatches = !miniCart || miniCart.querySelectorAll('[id^="MiniCartItem-"]').length === expectedLines;
    return mainMatches && miniMatches;
  };

  const refreshCartSurfaces = async (sections = getCartSurfaceSections()) => {

    if (!sections.size) return false;

    const url = new URL(window.location.href);
    url.searchParams.set('sections', Array.from(sections.keys()).join(','));
    url.searchParams.set('_qm_cart', String(Date.now()));
    const response = await fetch(url.toString(), {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
    if (!response.ok) return false;

    const renderedSections = await response.json();
    for (const sectionId of sections.keys()) {
      if (renderedSections[sectionId]) continue;
      const singleSectionUrl = new URL(window.location.href);
      singleSectionUrl.searchParams.delete('sections');
      singleSectionUrl.searchParams.set('section_id', sectionId);
      singleSectionUrl.searchParams.set('_qm_cart', String(Date.now()));
      const singleSectionResponse = await fetch(singleSectionUrl.toString(), {
        headers: { Accept: 'text/html' },
        cache: 'no-store'
      });
      if (singleSectionResponse.ok) {
        renderedSections[sectionId] = await singleSectionResponse.text();
      }
    }
    return applyRenderedCartSections(renderedSections, sections);
  };

  const addVariant = async (variantId, button) => {
    if (!variantId || !button || button.disabled) return false;
    const originalText = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Añadiendo…';
    try {
      const requestedSections = getCartSurfaceSections();
      const addPayload = { items: [{ id: Number(variantId), quantity: 1 }] };
      if (requestedSections.size) {
        addPayload.sections = Array.from(requestedSections.keys());
        addPayload.sections_url = window.location.pathname + window.location.search;
      }
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(addPayload)
      });
      if (!response.ok) throw new Error('No se pudo añadir');
      const addResult = await response.json();
      const cart = await getCart();
      updateCartCounts(cart);
      const expectedLines = cart.items.length;
      const bundledSectionsApplied = applyRenderedCartSections(addResult?.sections, requestedSections);
      if (!bundledSectionsApplied || !cartSurfaceLineCountsMatch(expectedLines)) {
        await new Promise((resolve) => window.setTimeout(resolve, 250));
        await refreshCartSurfaces(requestedSections);
      }
      if (!cartSurfaceLineCountsMatch(expectedLines)) {
        await new Promise((resolve) => window.setTimeout(resolve, 500));
        await refreshCartSurfaces(requestedSections);
      }
      button.textContent = 'Añadido';
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
      window.setTimeout(() => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = originalText;
      }, 1300);
      scheduleCrossSell();
      return true;
    } catch (_error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = 'Reintentar';
      return false;
    }
  };

  window.QMCart = Object.assign(window.QMCart || {}, { addVariant: addVariant });

  const productAvailable = (product) =>
    product?.available === true || product?.variants?.some((variant) => variant.available === true);

  const productKind = (line) => {
    const value = String(line.product_type || '') + ' ' + String(line.product_title || line.title || '');
    if (/tocadiscos|giradiscos/i.test(value)) return 'turntable';
    if (/(^|[\s(])(?:\d+x)?CD(?:[\s)]|$)/i.test(value)) return 'cd';
    if (/vinil|(?:^|[\s(])(?:\d+x)?LP(?:[\s)]|$)/i.test(value)) return 'vinyl';
    return 'general';
  };

  const recommendationProductKind = (product) => {
    const tags = Array.isArray(product?.tags) ? product.tags.join(' ') : String(product?.tags || '');
    const value = [product?.product_type, product?.title, tags].filter(Boolean).join(' ');
    if (/revista/i.test(value)) return 'magazine';
    if (/accesorio|limpiador|cepillo|antiest[aá]tico|estabilizador|pesa|funda|kit|l[ií]quido/i.test(value)) {
      return 'accessory';
    }
    if (/tocadiscos|giradiscos/i.test(value)) return 'turntable';
    if (/altavoz|speaker|audio/i.test(value)) return 'audio';
    if (/camiseta|merch/i.test(value)) return 'merch';
    if (/(^|[\s(])(?:\d+x)?CD(?:[\s)]|$)/i.test(value)) return 'cd';
    if (/vinil|(?:^|[\s(])(?:\d+x)?LP(?:[\s)]|$)|(?:^|\s)(?:7|10|12)["”](?:\s|$)/i.test(value)) {
      return 'vinyl';
    }
    return 'general';
  };

  const fetchProducts = async (url) => {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 3500);
    try {
      const response = await fetch(url, {
        headers: { Accept: 'application/json' },
        signal: controller.signal
      });
      if (!response.ok) return [];
      const payload = await response.json();
      return Array.isArray(payload.products) ? payload.products : [];
    } catch (_error) {
      return [];
    } finally {
      window.clearTimeout(timeout);
    }
  };

  const dismissedMagazineHandles = () => {
    try {
      return new Set(JSON.parse(sessionStorage.getItem('qm-dismissed-magazines') || '[]'));
    } catch (_error) {
      return new Set();
    }
  };

  const dismissMagazine = (handle) => {
    const dismissed = dismissedMagazineHandles();
    dismissed.add(handle);
    try {
      sessionStorage.setItem('qm-dismissed-magazines', JSON.stringify(Array.from(dismissed)));
    } catch (_error) {
      // Session persistence is optional.
    }
    scheduleCrossSell();
  };

  const recommendationCandidates = async (cart) => {
    const base = ['vinyl', 'turntable', 'cd']
      .map((kind) => cart.items.find((item) => productKind(item) === kind))
      .find(Boolean) || cart.items[0];
    if (!base) return [];
    const inCart = new Set(cart.items.map((item) => String(item.product_id)));
    const dismissed = dismissedMagazineHandles();
    const kind = productKind(base);
    const productId = encodeURIComponent(base.product_id);
    const fallbackUrls = kind === 'vinyl'
      ? ['/collections/limpiadores-para-giradiscos-y-vinilos/products.json?limit=10']
      : kind === 'turntable'
        ? [
            '/collections/limpiadores-para-giradiscos-y-vinilos/products.json?limit=10',
            '/collections/altavoces/products.json?limit=4'
          ]
        : kind === 'cd'
          ? [
              '/collections/cd/products.json?limit=10',
              '/collections/revistas/products.json?limit=8'
            ]
          : ['/collections/merchandising/products.json?limit=8'];
    const [recommended, related, ...fallbackGroups] = await Promise.all([
      fetchProducts('/recommendations/products.json?product_id=' + productId + '&limit=8&intent=complementary'),
      fetchProducts('/recommendations/products.json?product_id=' + productId + '&limit=8&intent=related'),
      ...fallbackUrls.map((url) => fetchProducts(url))
    ]);

    const contextual = recommended.concat(related);
    const fallback = fallbackGroups.flat();
    const only = (products, ...kinds) => products.filter((product) => kinds.includes(recommendationProductKind(product)));
    let orderedCandidates;

    if (kind === 'vinyl') {
      orderedCandidates = only(contextual, 'magazine')
        .concat(only(contextual, 'accessory'))
        .concat(only(fallback, 'accessory'))
        .concat(only(fallback, 'magazine'));
    } else if (kind === 'turntable') {
      orderedCandidates = only(contextual, 'accessory', 'audio')
        .concat(only(fallback, 'accessory', 'audio'));
    } else if (kind === 'cd') {
      orderedCandidates = only(contextual, 'cd')
        .concat(only(fallback, 'cd'))
        .concat(only(contextual, 'magazine', 'audio', 'merch'))
        .concat(only(fallback, 'magazine', 'audio', 'merch'));
    } else {
      orderedCandidates = contextual.concat(fallback);
    }

    const unique = new Map();
    orderedCandidates.forEach((product) => {
      if (!product || !productAvailable(product)) return;
      if (inCart.has(String(product.id))) return;
      if (dismissed.has(product.handle)) return;
      if (!unique.has(product.handle)) unique.set(product.handle, product);
    });
    return Array.from(unique.values()).slice(0, 3);
  };

  const createCrossSell = (products, targetId) => {
    const section = document.createElement('section');
    section.className = 'qm-cart-cross-sell';
    section.id = targetId;
    section.dataset.qmSignature = products.map((product) => product.handle).join('|');
    section.setAttribute('aria-labelledby', targetId + '-heading');

    const heading = document.createElement('h3');
    heading.className = 'qm-cart-cross-sell__heading';
    heading.id = targetId + '-heading';
    heading.textContent = 'Completa tu pedido';
    section.appendChild(heading);

    const list = document.createElement('div');
    list.className = 'qm-cart-cross-sell__list';
    products.forEach((product) => {
      const variant = product.variants?.find((item) => item.available === true) || product.variants?.[0];
      if (!variant) return;
      const item = document.createElement('article');
      item.className = 'qm-cart-cross-sell__item';

      const imageLink = document.createElement('a');
      imageLink.href = '/products/' + product.handle;
      imageLink.setAttribute('aria-label', 'Ver ' + product.title);
      const image = document.createElement('img');
      image.src = product.images?.[0]?.src || product.featured_image || '';
      image.alt = product.images?.[0]?.alt || product.title;
      image.width = 62;
      image.height = 62;
      image.loading = 'lazy';
      imageLink.appendChild(image);
      item.appendChild(imageLink);

      const copy = document.createElement('div');
      copy.className = 'qm-cart-cross-sell__copy';
      const title = document.createElement('a');
      title.className = 'qm-cart-cross-sell__title';
      title.href = '/products/' + product.handle;
      title.textContent = product.title;
      const price = document.createElement('span');
      price.className = 'qm-cart-cross-sell__price';
      const rawPrice = variant.price || 0;
      const normalizedPrice = typeof rawPrice === 'number' ? Number(rawPrice) / 100 : Number(rawPrice);
      price.textContent = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' })
        .format(normalizedPrice);
      copy.append(title, price);
      item.appendChild(copy);

      const add = document.createElement('button');
      add.type = 'button';
      add.className = 'qm-cart-cross-sell__add';
      add.textContent = 'Añadir';
      add.setAttribute('aria-label', 'Añadir ' + product.title + ' al carrito');
      add.addEventListener('click', () => addVariant(variant.id, add));
      item.appendChild(add);

      if (/revista/i.test(String(product.product_type || ''))) {
        const dismiss = document.createElement('button');
        dismiss.type = 'button';
        dismiss.className = 'qm-cart-cross-sell__dismiss';
        dismiss.textContent = '×';
        dismiss.setAttribute('aria-label', 'No mostrar esta revista durante la sesión');
        dismiss.addEventListener('click', () => dismissMagazine(product.handle));
        item.appendChild(dismiss);
      }
      list.appendChild(item);
    });
    section.appendChild(list);
    const status = document.createElement('p');
    status.className = 'qm-cart-cross-sell__status';
    status.setAttribute('aria-live', 'polite');
    section.appendChild(status);
    return section;
  };

  let crossSellTimer = 0;
  let crossSellToken = 0;
  const setCrossSellState = (state) => {
    document.documentElement.dataset.qmCrossSellState = state;
  };

  const renderCrossSell = async () => {
    const token = ++crossSellToken;
    const miniTarget = document.getElementById('header-mini-cart-footer');
    const cartTarget = document.querySelector('#main-cart-footer, .main-cart-footer, .cart-footer');
    if (!miniTarget && !cartTarget) {
      setCrossSellState('no-target');
      return;
    }
    setCrossSellState('loading');
    try {
      const cart = await getCart();
      if (token !== crossSellToken) {
        setCrossSellState('stale-cart');
        return;
      }
      updateCartCounts(cart);
      if (!cart.items.length) {
        document.querySelectorAll('.qm-cart-cross-sell').forEach((node) => node.remove());
        setCrossSellState('empty-cart');
        return;
      }
      setCrossSellState('fetching-products');
      const products = await recommendationCandidates(cart);
      if (token !== crossSellToken) {
        setCrossSellState('stale-products');
        return;
      }
      if (!products.length) {
        document.querySelectorAll('.qm-cart-cross-sell').forEach((node) => node.remove());
        setCrossSellState('empty-products');
        return;
      }
      const signature = products.map((product) => product.handle).join('|');
      const miniCurrent = document.getElementById('qm-cart-cross-sell-mini');
      const cartCurrent = document.getElementById('qm-cart-cross-sell-page');
      const miniIsCurrent = !miniTarget || miniCurrent?.dataset.qmSignature === signature;
      const cartIsCurrent = !cartTarget || cartCurrent?.dataset.qmSignature === signature;
      if (miniIsCurrent && cartIsCurrent) {
        setCrossSellState('stable-' + products.length);
        return;
      }
      document.querySelectorAll('.qm-cart-cross-sell').forEach((node) => node.remove());
      if (miniTarget) miniTarget.prepend(createCrossSell(products, 'qm-cart-cross-sell-mini'));
      if (cartTarget) cartTarget.prepend(createCrossSell(products, 'qm-cart-cross-sell-page'));
      setCrossSellState('rendered-' + products.length);
    } catch (error) {
      setCrossSellState('error-' + String(error?.name || 'unknown').toLowerCase());
      // The checkout action remains available even if recommendations fail.
    }
  };

  function scheduleCrossSell() {
    window.clearTimeout(crossSellTimer);
    crossSellTimer = window.setTimeout(renderCrossSell, 120);
  }

  let miniCartSyncTimer = 0;
  let miniCartSyncToken = 0;

  const syncMiniCartFromPage = async () => {
    const token = ++miniCartSyncToken;
    try {
      const cart = await getCart();
      if (token !== miniCartSyncToken) return;
      updateCartCounts(cart);
      const miniSections = new Map(
        Array.from(getCartSurfaceSections()).filter(([_sectionId, selectors]) => (
          selectors.includes('#header-mini-cart-content')
        ))
      );
      if (miniSections.size) {
        const expectedLines = cart.items.length;
        await refreshCartSurfaces(miniSections);
        if (token !== miniCartSyncToken) return;
        if (!cartSurfaceLineCountsMatch(expectedLines)) {
          await new Promise((resolve) => window.setTimeout(resolve, 250));
          if (token !== miniCartSyncToken) return;
          await refreshCartSurfaces(miniSections);
        }
        if (!cartSurfaceLineCountsMatch(expectedLines)) {
          await new Promise((resolve) => window.setTimeout(resolve, 500));
          if (token !== miniCartSyncToken) return;
          await refreshCartSurfaces(miniSections);
        }
      }
      if (token === miniCartSyncToken) {
        scheduleCrossSell();
      }
    } catch (_error) {
      // The main cart remains authoritative if its compact mirror cannot refresh.
    }
  };

  function scheduleMiniCartSync() {
    window.clearTimeout(miniCartSyncTimer);
    miniCartSyncTimer = window.setTimeout(syncMiniCartFromPage, 180);
  }

  const observeDynamicAreas = () => {
    const miniCart = document.getElementById('HeaderMiniCart');
    if (miniCart && miniCart.dataset.qmObserved !== 'true') {
      miniCart.dataset.qmObserved = 'true';
      new MutationObserver((mutations) => {
        const affectsCartLines = mutations.some((mutation) => {
          if (mutation.target.nodeType === Node.ELEMENT_NODE) {
            if (mutation.target.closest('.qm-cart-cross-sell')) return false;
            if (mutation.target.closest('[id^="MiniCartItem-"]')) return true;
          }
          const changedNodes = Array.from(mutation.addedNodes).concat(Array.from(mutation.removedNodes));
          return changedNodes.some((node) => node.nodeType === Node.ELEMENT_NODE && (
            node.matches('[id^="MiniCartItem-"], #header-mini-cart-content, #header-mini-cart-footer') ||
            node.querySelector('[id^="MiniCartItem-"], #header-mini-cart-content, #header-mini-cart-footer')
          ));
        });
        if (affectsCartLines) scheduleCrossSell();
      }).observe(miniCart, { childList: true, subtree: true });

      const miniCartToggle = miniCart.querySelector('.dropdown-modal-toggle');
      if (miniCartToggle && miniCartToggle.dataset.qmCrossSellBound !== 'true') {
        miniCartToggle.dataset.qmCrossSellBound = 'true';
        miniCartToggle.addEventListener('click', scheduleCrossSell);
      }
    }
    const main = document.getElementById('MainContent');
    if (main && main.dataset.qmFilterObserved !== 'true') {
      main.dataset.qmFilterObserved = 'true';
      let filterTimer = 0;
      new MutationObserver((mutations) => {
        window.clearTimeout(filterTimer);
        filterTimer = window.setTimeout(enhanceFilters, 60);
        const cartLinesChanged = mutations.some((mutation) => {
          if (mutation.target.nodeType === Node.ELEMENT_NODE && mutation.target.closest('#main-cart-items')) {
            return true;
          }
          const changedNodes = Array.from(mutation.addedNodes).concat(Array.from(mutation.removedNodes));
          return changedNodes.some((node) => node.nodeType === Node.ELEMENT_NODE && (
            node.matches('#main-cart-items, [id^="CartItem-"]') ||
            node.querySelector('#main-cart-items, [id^="CartItem-"]')
          ));
        });
        if (cartLinesChanged) scheduleMiniCartSync();
      }).observe(main, { childList: true, subtree: true });
    }

    if (document.documentElement.dataset.qmCartEventsBound !== 'true') {
      document.documentElement.dataset.qmCartEventsBound = 'true';
      document.addEventListener('cart:updated', scheduleCrossSell);
      document.addEventListener('cart:refresh', scheduleCrossSell);
      document.addEventListener('click', (event) => {
        const cartControl = event.target.closest?.(
          'cart-remove-button a, cart-items quantity-input button'
        );
        if (cartControl) window.setTimeout(scheduleMiniCartSync, 350);
      }, true);
      document.addEventListener('change', (event) => {
        if (event.target.matches?.('cart-items input[name="updates[]"]')) {
          window.setTimeout(scheduleMiniCartSync, 250);
        }
      }, true);
    }
  };

  const initialize = () => {
    setPageContext();
    enhanceFilters();
    updateHeaderGeometry();
    bindMenuPositioning();
    bindSearchOutsideClose();
    observeDynamicAreas();
    scheduleCrossSell();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  window.addEventListener('resize', () => {
    updateHeaderGeometry();
    document.querySelectorAll('.qm-navigation-item').forEach(positionMenuPanel);
  }, { passive: true });
  window.addEventListener('scroll', updateHeaderGeometry, { passive: true });
  document.addEventListener('shopify:section:load', initialize);
})();
